export type GenerationParams = {
  numberOfShots?: number
  quality?: GenerationQuality
  imageProvider?: string
}

export type GenerateStoryboardParams = GenerationParams & {
  generateImages: boolean
}

export type ImageGenerationDialogParams = GenerationParams

export enum GenerationQuality {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export const GENERATION_QUALITY_OPTIONS: { label: string; value: GenerationQuality }[] = [
  { label: 'Low', value: GenerationQuality.Low },
  { label: 'Medium', value: GenerationQuality.Medium },
  { label: 'High', value: GenerationQuality.High },
]
